import { useMutation } from '@tanstack/react-query';
import { useAuthenticationContext } from 'Foundation/Authentication';
import {
  patchMasterOverrideApprovalDate,
  patchMasterOverrideApprove,
  patchMasterOverrideFinalize,
  patchMasterPoolOverrideOfferDate,
  patchMasterPoolOverrideCitadalDate,
  patchReverseApproval,
  patchReverseFinalizationMasterPool,
  patchReverseWithdrawalMasterPool,
  patchWithdrawMasterPool,
  patchReRunPricingScenario,
  patchMasterPoolReleaseStatus
} from '../../HbtMasterPool/ValidationInventoryService';
import { Remark } from '../types';

interface PatchMasterPoolParams {
  cmhcAccountNumber: string;
  date: string;
}
interface MasterPoolParams {
  cmhcAccountNumber: string;
  remarks?: Remark | null;
}

export const usePatchMasterPoolOverrideOfferDate = () => {
  const authContext = useAuthenticationContext();
  return useMutation<any | null, Error, PatchMasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber, date }) => {
      const response = await patchMasterPoolOverrideOfferDate(cmhcAccountNumber, date, authContext);
      return response;
    }
  });
};

export const usePatchMasterPoolOverrideApprovalDate = () => {
  const authContext = useAuthenticationContext();
  return useMutation<any | null, Error, PatchMasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber, date }) => {
      const result = await patchMasterOverrideApprovalDate(cmhcAccountNumber, date, authContext);
      return result;
    }
  });
};
export const usePatchMasterPoolOverrideApprove = () => {
  const authContext = useAuthenticationContext();
  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchMasterOverrideApprove(cmhcAccountNumber, authContext);
      return result;
    }
  });
};

export const usePatchMasterPoolOverrideFinalize = () => {
  const authContext = useAuthenticationContext();
  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchMasterOverrideFinalize(cmhcAccountNumber, authContext);
      return result;
    }
  });
};

export const usePatchMasterPoolReverseApproval = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchReverseApproval(cmhcAccountNumber, authContext);
      return result;
    }
  });
};
export const usePatchMasterPoolWithDraw = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber, remarks }) => {
      const result = await patchWithdrawMasterPool(cmhcAccountNumber, remarks, authContext);
      return result;
    }
  });
};

export const usePatchMasterPoolReverseFinalization = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchReverseFinalizationMasterPool(cmhcAccountNumber, authContext);
      return result;
    }
  });
};
export const usePatchReverseWithdrawalMasterPool = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchReverseWithdrawalMasterPool(cmhcAccountNumber, authContext);
      return result;
    }
  });
};

export const usePatchMasterPoolOverrideCitadalDate = () => {
  const authContext = useAuthenticationContext();
  return useMutation<any | null, Error, PatchMasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber, date }) => {
      const response = await patchMasterPoolOverrideCitadalDate(
        cmhcAccountNumber,
        date,
        authContext
      );
      return response;
    }
  });
};

export const usePatchReRunPricingScenario = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchReRunPricingScenario(cmhcAccountNumber, authContext);
      return result;
    }
  });
};

export const usePatchMasterPoolReleaseWorkflowState = () => {
  const authContext = useAuthenticationContext();

  return useMutation<any | null, Error, MasterPoolParams>({
    mutationFn: async ({ cmhcAccountNumber }) => {
      const result = await patchMasterPoolReleaseStatus(cmhcAccountNumber, authContext);
      return result;
    }
  });
};
